import { render } from "./PanelCenterFooterDocumentCount.vue?vue&type=template&id=8e5296b4&scoped=true"
import script from "./PanelCenterFooterDocumentCount.vue?vue&type=script&lang=js"
export * from "./PanelCenterFooterDocumentCount.vue?vue&type=script&lang=js"

import "./PanelCenterFooterDocumentCount.vue?vue&type=style&index=0&id=8e5296b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e5296b4"]])

export default __exports__